module.exports = "pegasus/assets/gray-large-facebook.png";